import * as React from "react"
import { Box } from "@mui/material"
import { keyframes } from "@emotion/react"

const bounce = keyframes`
  0%,100% {opacity: 0;}
  30%, 80% {opacity: 1;}
`

export default function Logo({
  height,
  width,
  color,
  simple = false,
  animate = false,
  ...props
}: {
  height?: number | string
  width?: number | string
  color?: string
  simple?: boolean
  animate?: boolean
}) {
  if (simple) {
    return (
      <Box
        sx={{
          color: color || "gray.900",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          animation: animate ? `${bounce} 2s infinite ease-in-out` : "inherit",
        }}
        {...props}
      >
        <svg
          width={width || "24"}
          height={height || "30"}
          viewBox="0 0 48 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.5 5.728V31.9278C5.5 34.3426 6.48701 36.8764 8.37583 38.4437L8.38889 38.4545C9.7219 39.576 11.6875 40.3665 13.8593 40.7472C13.8419 28.5069 13.8592 22.0506 13.863 20.6434C13.8633 20.5265 13.8635 20.4444 13.8636 20.3968C13.8442 19.8145 13.8296 19.2603 13.8157 18.731C13.706 14.5549 13.6371 11.9347 11.5658 9.40517C9.90079 7.37188 7.82187 6.19062 5.5 5.728ZM19.19 46.0092C19.7773 48.8846 21.1215 51.3286 23.531 53.0264C25.6218 54.4997 28.1523 54.4993 31.5835 54.4986C31.6546 54.4986 31.7261 54.4986 31.798 54.4986H42.2909C41.9237 51.3804 41.0953 49.079 38.7983 47.4788C37.6698 46.6927 36.8107 46.3656 35.8945 46.2029C34.8688 46.0206 33.7032 46.0255 31.7877 46.0542L31.7644 46.0546L19.19 46.0092ZM18.8597 41.008C18.8417 28.6397 18.8591 22.12 18.8629 20.6628C18.8634 20.4902 18.8637 20.3886 18.8637 20.3568V20.3147L18.8622 20.2727C18.8445 19.7454 18.8345 19.2077 18.8243 18.6619C18.7492 14.6406 18.6661 10.1842 15.4343 6.23742C12.1319 2.20449 7.63952 0.467814 2.98248 0.500451L0.5 0.517849V31.9278C0.5 35.5489 1.94895 39.6042 5.17655 42.2861C7.61194 44.332 10.8987 45.4385 14.0868 45.8342C14.7108 50.0556 16.5619 54.2323 20.6509 57.1136C24.0848 59.5333 28.1376 59.5146 31.1503 59.5006C31.372 59.4996 31.5882 59.4986 31.798 59.4986H47.6402L47.4963 56.8624C47.2564 52.4659 46.733 46.9128 41.6563 43.3762C39.995 42.2189 38.4678 41.5817 36.769 41.2799C35.2059 41.0023 33.5568 41.027 31.8009 41.0534L31.736 41.0544L18.8597 41.008Z"
            fill="currentColor"
          />
        </svg>
      </Box>
    )
  }

  return (
    <Box
      sx={{
        color: color || "gray.900",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        animation: animate ? `${bounce} 2s infinite ease-in-out` : "inherit",
      }}
      {...props}
    >
      <svg
        width={width || "70"}
        height={height || "30"}
        viewBox="0 0 139 61"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.59422 5.82553V32.405C5.59422 34.8548 6.59554 37.4253 8.51173 39.0153L8.52498 39.0263C9.87731 40.164 11.8714 40.9661 14.0747 41.3522C14.057 28.9346 14.0746 22.3847 14.0784 20.9571C14.0787 20.8385 14.0789 20.7552 14.079 20.7069C14.0594 20.1162 14.0446 19.5539 14.0305 19.017C13.9191 14.7803 13.8493 12.1222 11.7479 9.55599C10.0588 7.49323 7.94975 6.29485 5.59422 5.82553ZM19.4826 46.6905C20.0785 49.6076 21.4422 52.087 23.8865 53.8094C26.0076 55.3041 28.5748 55.3036 32.0557 55.303C32.1279 55.303 32.2004 55.303 32.2734 55.303H42.9183C42.5458 52.1396 41.7054 49.8048 39.3751 48.1814C38.2303 47.3839 37.3587 47.0521 36.4292 46.887C35.3886 46.7021 34.2062 46.7071 32.2629 46.7362L32.2393 46.7365L19.4826 46.6905ZM19.1475 41.6168C19.1293 29.0693 19.1469 22.4551 19.1508 20.9768C19.1513 20.8016 19.1516 20.6986 19.1516 20.6663V20.6237L19.1501 20.581C19.1321 20.0461 19.122 19.5006 19.1116 18.9469C19.0355 14.8673 18.9511 10.3463 15.6725 6.34233C12.3222 2.25095 7.76475 0.489106 3.04022 0.522217L0.521759 0.539866V32.405C0.521759 36.0787 1.9917 40.1927 5.26609 42.9135C7.73677 44.989 11.0712 46.1116 14.3055 46.513C14.9385 50.7955 16.8165 55.0328 20.9647 57.9559C24.4484 60.4107 28.5599 60.3916 31.6162 60.3775C31.8412 60.3764 32.0605 60.3754 32.2734 60.3754H48.3451L48.1991 57.701C47.9557 53.2408 47.4248 47.6072 42.2745 44.0193C40.5892 42.8452 39.0398 42.1988 37.3164 41.8927C35.7306 41.611 34.0576 41.6362 32.2763 41.6629L32.2105 41.6639L19.1475 41.6168Z"
          fill="currentColor"
        />
        <path
          d="M55.1269 49.058H79.9713V42.2926H63.3325V10.2469H55.1269V49.058Z"
          fill="currentColor"
        />
        <path
          d="M102.319 36.6642C102.338 40.568 99.6662 42.6147 96.7667 42.6147C93.7156 42.6147 91.7448 40.4733 91.7258 37.0432V19.9497H83.6528V38.4835C83.6718 45.2868 87.6514 49.437 93.5072 49.437C97.8848 49.437 101.031 47.1818 102.338 43.7707H102.641V49.058H110.392V19.9497H102.319V36.6642Z"
          fill="currentColor"
        />
        <path
          d="M115.097 49.058H139.563V42.6147H125.691V42.4063L139.07 25.199V19.9497H115.59V26.3929H129.348V26.6014L115.097 44.2445V49.058Z"
          fill="currentColor"
        />
      </svg>
    </Box>
  )
}
